/**
 * @file Renders the platform logo image, or the organization name as a
 * text fallback when there is no image.
 */
import { Typography } from "antd";

import { getResizedImageUrl } from "@components/Storage";
import type { ImgixOptions } from "@components/Storage";

const { Title } = Typography;

type Props = {
  src?: string;
  height?: number;
  alt: string;
};

/**
 * Renders the given logo image trimmed and resized to the given height,
 * or the alt text as a heading when no image is given.
 */
const Logo = ({
  src = undefined,
  height = 36,
  alt,
}: Props): JSX.Element => {
  const marginTop = -1 * height / 2;

  const imageContainerStyle = {
    position: "absolute" as const,
    marginTop,
    height,
  };

  const resizeOptions: ImgixOptions = {
    trim: "color",
    "trim-color": "00FFFFFF",
  };

  return (
    <>
      {
        src && (
          <div style={imageContainerStyle}>
            <img
              alt={alt}
              src={getResizedImageUrl(src, undefined, height * 2, resizeOptions)}
              height={height}
            />
          </div>
        )
      }

      {
        !src && (
          <Title level={4} style={{ margin: 0 }}>{alt}</Title>
        )
      }
    </>
  );
};

export default Logo;
